import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
//import './App.css';
//import firebase from './../Firestore'

class Precio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      precio: []
    };
    this.yaConvertido = false;
    //this.test = "test";

  }

convertirPrecio(precio){
  // console.log("en precio", this.props.precioAConvertir)
  var currentComponent = this

  let precioConvertido = ""

  if (typeof(this.props.precioAConvertir) !== "object"){
    // es precio unico
    precioConvertido = this.props.precioAConvertir

  }else{
    // tiene distintos tamanos
    Object.entries(this.props.precioAConvertir).forEach(([key, value]) => {
        //console.log(key + ' ' + value); // "a 5", "b 7", "c 9"
        if(value > 0) precioConvertido += key.toUpperCase() + ": $ " + value + " ";
    });
  }



  this.yaConvertido = true

  currentComponent.setState({
    precio: precioConvertido
  }) ;

}




componentDidUpdate(){
  if(!this.yaConvertido) this.convertirPrecio(this.props.precioAConvertir);
  // console.log("did update ", this.props.precioAConvertir )
}

  async componentDidMount() {

    if(this.props.precioAConvertir !== undefined) this.convertirPrecio(this.props.precioAConvertir)

  }

  render() {
    return (


      <span>{this.state.precio}</span>



    );
  }
}

export default Precio;
